import { useState, useMemo, useCallback } from "react";
import RegistrationForm from "../../../frontend/registration-form/RegistrationForm";
import { jsonParse, useWPAjax } from "../../../../../wp-utils/v1";
import ApplicationForm from "../Members/ApplicationForm";

const Profile = ({ auth, nonce, member }) => {
  const [formData, setFormData] = useState(member || {});
  const [error, setError] = useState(null);
  const [notice, setNotice] = useState(null);
  const [tab, setTab] = useState("application-copy");
  // const { data, saveData, isLoading, error: phpError } = useWPAjax("ajax_request_handler", { nonce, model: "Users", method: "create_account" }, true);
  const { data: fields = [] } = useWPAjax("ajax_request_handler", { nonce, model: "Users", method: "registration_fields" });

  const skipableFields = useCallback(() => {
    if (member?.is_approved) {
      return ["email", "password", "confirm_password", "year_of_ssc_exam", "school_of_ssc_exam", "ssc_roll", "ssc_certificate", "NID_NO", "is_registration_fee_paid", "payment_document", "mobile_no"];
    } else {
      return ["email", "password", "confirm_password", "mobile_no"];
    }
  }, [member]);

  const [loading, setLoading] = useState(null);

  const requiredFields = useMemo(
    () =>
      fields
        ?.filter((item) => !["email", "password"].includes(item.name))
        .map((field) => (field.isRequired ? field.name : false))
        .filter((field) => field),
    []
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    let shouldProcced = true;

    requiredFields?.map((field) => {
      if (!formData[field]) {
        document.querySelector(`.${field}`).classList.add("field_error");
        setError("Required field missing");
        shouldProcced = false;
      } else {
        document.querySelector(`.${field}`).classList.remove("field_error");
      }
    });

    if (!shouldProcced) {
      return false;
    }

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (!["profile_pic", "signature", "payment_document"].includes(key) && typeof formData[key] === "object") {
        data.append(key, JSON.stringify(formData[key]));
      } else {
        data.append(key, formData[key]);
      }
    });

    data.append("nonce", nonce);
    data.append("model", "Users");
    data.append("method", "create_account");

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(`${window.location.origin + window._wpUtilSettings.ajax.url}?action=ajax_request_handler&nonce=${nonce}&model=Users&method=create_account`, {
        method: "POST",
        body: data,
      });

      const response = await res.json();
      setLoading(false);
      if (!response.success) {
        setError(response.data);
        if (!response.success && Array.isArray(response.data?.errors)) {
          response.data?.errors.map((item) => {
            document.querySelector(`.${Object.keys(item)?.[0]}`)?.classList.add("field_error");
          });
        }
        return false;
      }

      setLoading(false);
      setNotice("profile updated successfully!");
      setTimeout(() => {
        setNotice(null);
      }, 2000);
      const contentContainer = document.querySelector(".mmmbaa_r_form ");
      contentContainer.scrollTop = contentContainer.scrollHeight;
    } catch (error) {
      setLoading(false);
    }
  };

  if (!auth) {
    return <h3>Loading...</h3>;
  }

  return (
    <div className="h-screen overflow-y-scroll">
      <div className="text-center mb-2">
        <h3 className="text-3xl">Profile</h3>
      </div>
      <div className="text-end mr-5">
        <button className="border-white button px-5 py-3 bg-gray-800 text-white rounded hover:bg-gray-600" onClick={() => setTab(tab === "edit" ? "application-copy" : "edit")}>
          {tab === "edit" ? "Exit" : "Edit"}
        </button>
      </div>
      {tab === "application-copy" ? (
        <ApplicationForm data={formData} />
      ) : (
        <>
          {!fields && <h3>Loading...</h3>}
          <RegistrationForm
            editable={true}
            loading={loading}
            error={error}
            fields={jsonParse(fields)?.filter((field) => !skipableFields().includes(field.name))}
            formData={formData}
            notice={notice}
            setFormData={setFormData}
            onSubmit={onSubmit}
          />
        </>
      )}
    </div>
  );
};

export default Profile;
